module.exports = __webpack_public_path__ + "static/media/bh.18fac7d8.svg";